<template>
    <div>
      <h1>首页</h1>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Home'
  }
  </script>
  
  <style scoped>
  /* ...样式代码... */
  </style>